import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { UserRole } from '@/entities/admin-user.entity';
import { SearchIcon } from 'lucide-react';
import { useEffect, useState } from 'react';

interface UsersHeaderProps {
	search: string;
	onSearchChange: (value: string) => void;
	role: UserRole | 'all';
	onRoleChange: (value: UserRole | 'all') => void;
}

export default function UsersHeader({ search, onSearchChange, role, onRoleChange }: UsersHeaderProps) {
	const [localSearch, setLocalSearch] = useState(search);

	useEffect(() => {
		const timer = setTimeout(() => onSearchChange(localSearch), 300);
		return () => clearTimeout(timer);
	}, [localSearch, onSearchChange]);

	return (
		<div className='flex gap-2'>
			<InputGroup className='flex-1 min-w-0'>
				<InputGroupInput placeholder='Поиск по нику…' value={localSearch} onChange={e => setLocalSearch(e.target.value)} />
				<InputGroupAddon>
					<SearchIcon size={16} />
				</InputGroupAddon>
			</InputGroup>
			<Select value={role} onValueChange={v => onRoleChange(v as UserRole | 'all')}>
				<SelectTrigger className='w-[120px] shrink-0'>
					<SelectValue placeholder='Роль' />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value='all'>Все</SelectItem>
					<SelectItem value='worker'>Worker</SelectItem>
					<SelectItem value='carder'>Carder</SelectItem>
					<SelectItem value='partner'>Partner</SelectItem>
					<SelectItem value='admin'>Admin</SelectItem>
					<SelectItem value='regwait'>Ожидание</SelectItem>
				</SelectContent>
			</Select>
		</div>
	);
}
